import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { AuthContext } from '../model/auth-context';
import { TranslateService } from '@ngx-translate/core';
import { SharedHandlersService } from '../shared/shared-handlers.service';
import { environment } from 'src/environments/environment';
import { LoginInputModel } from './LoginInputModel';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { Subscription } from 'rxjs';
import { ErrorDetailsService } from "bi-modules";
import { LanguagesEnum } from '../Languages';
import { AdminRouteGuard } from '../core/admin-route.guard';
import { CookieService } from 'ngx-cookie-service';
import { UserInfo } from '../userInfo';

export enum AuthTypeEnum {
  SalesBuzz,
  ActiveDirectory,
  SSO = 2
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription;
  isLoged = false;
  public login: string;
  public creds: LoginInputModel;
  errorMessage: string = "";
  authContext: AuthContext;
  public placeHolder: any;
  public Displayedpassword: string = '';
  public defaultItem: any;
  public listItems: any;
  browsertype: any;
  _appVersion: any;
  _appReleaseDate: any;
  public AuthTypeSSO = AuthTypeEnum.SSO;
  public SSOTokenObject;
  public SSOError: string = '';

  constructor(public Shared: SharedHandlersService,
    private router: Router,
    public translate: TranslateService,
    @Inject(LOCALE_ID) public localeId: string,
    private _adminRouteGuard: AdminRouteGuard,
    private loginService: LoginService,
    private cookieService: CookieService,
    public errorDetailsService: ErrorDetailsService
  ) {
    this.creds = new LoginInputModel();

    if (UserInfo.BUID && this._adminRouteGuard.isLoggedIn()) {
      this.ClearSSOCookies();
      this.router.navigate(["home"]);
    }
    else {
      this.loginService.isLoggedIn = false;

      let SSOToken = this.cookieService.get("Token");
      let SSOUser = this.cookieService.get("SSOUser");
      this.SSOError = this.cookieService.get("SSOError");

      this.ClearSSOCookies();

      if (SSOToken && SSOUser) {
        this.isLoged = true;
        this.SSOTokenObject = JSON.parse(SSOToken);
        this.FillSSOCredentials(SSOUser);
      }
    }
  }
  ngOnInit() {
    this._appVersion = environment.version;
    this._appReleaseDate = environment.timeStamp;
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  Return2Login() {
    this.isLoged = false;
  }

  FillListItems(args) {
    if (args != null) {
      this.defaultItem = args.BUList[0];
      this.listItems = args.BUList;
      this.creds = args.creds;
      this.Displayedpassword = args.password;
      this.isLoged = true;
    }
  }

  ClearSSOCookies() {
    if (this.cookieService.get("Token") || this.cookieService.get("SSOUser") || this.cookieService.get("SSOError")) {
      this.loginService.ClearSSOCookies().subscribe();
    }
  }

  FillSSOCredentials(SSOUser) {
    this.loginService.RemoveLocalStorageTokens();

    this.creds.Username = SSOUser;
    this.creds.AuthType = AuthTypeEnum.SSO;
    this.creds.Language = String(LanguagesEnum.English);
    this.creds.Password = '';
    this.creds.RememberLogin = '';
    this.creds.ReturnUrl = '';
    this.creds.UserCode = '';

    this.loginService.setLoginClaims(this.SSOTokenObject, this.creds, this.defaultItem);

    this.loginService.getBusinessUnits(SSOUser).subscribe(businessUnits => {
      this.listItems = [];
      businessUnits.value.map(bu => this.listItems.push({
        BUID: bu.BUID,
        Description: bu.HH_SA_BU.Description,
        DescriptionA: bu.HH_SA_BU.DescriptionA
      }));

      var args = { BUList: this.listItems, creds: this.creds, password: this.Displayedpassword };
      this.FillListItems(args);
    });
  }
}
